import DocImage from "../../Assets/Images/doc.png";
import PDFImage from "../../Assets/Images/pdf.png";
import URLImage from "../../Assets/Images/url.png";
import VideoImage from "../../Assets/Images/video.png";
import ActionButton from "../../Components/UI/Buttons/ActionButton";
import { useFileViewer } from "../../Context/FileViewerContext";
import { useWorkspaceStore } from "../../Context/store";
import { getFileType, getLocalTime } from "../../Utils/Helper";
// import { Typography } from "@material-tailwind/react";

export const formatCitation = (citation) => {
  let title = "";
  let description = "";

  if (citation?.refFileType === "url") {
    if (!citation?.note) {
      title = citation?.refUrl;
      description = "";
    } else {
      // Assuming title and description are separated by 'Title:' and 'Description:' in citationNote
      const noteParts = citation?.note?.split("\n");
      title = noteParts[0]?.replace("Title: ", "").trim() || "";
      description = noteParts[1]?.replace("Description: ", "").trim() || "";
    }
  } else {
    // Extract the file name from the URL as the title
    const apiTitle = citation?.refUrl?.split("/").pop();
    title = apiTitle?.split("_")?.slice(1)?.join(" ");
    description = citation.note;
  }

  return { title, description };
};

const LibraryCard = ({ Actions, Citation, menuChildren = <></> }) => {
  const { title } = formatCitation({
    ...Citation,
    citationType: Citation?.refFileType,
  });
  const { selectedWorkspace } = useWorkspaceStore();
  const { handleFile } = useFileViewer();

  const fileType = getFileType(`hello.${Citation?.refFileType}`);
  const Src =
    fileType === "doc"
      ? DocImage
      : fileType === "pdf"
      ? PDFImage
      : Citation?.refFileType === "url"
      ? URLImage
      : fileType === "video"
      ? VideoImage
      : Citation?.refUrl;

  const handleClick = (citation) => {
    if (citation?.refFileType === "url") {
      window.open(citation.refUrl, "_blank");
      return;
    }
    handleFile({
      fileUrl: citation?.refUrl,
      fileType: citation?.refFileType,
      fileName: title,
      fileUploadedAt: getLocalTime(citation?.createdAt),
      createdBy: citation?.createdByUserName,
      creatorImage: citation?.createdByUserImage,
      channelName: selectedWorkspace?.workSpaceName,
    });
    return;
  };
  return (
    <div className="flex gap-2 w-full items-center">
      <figure className="w-14">
        <img
          id={`${Citation?.id}`}
          className="h-12 w-12 rounded-md object-cover object-center cursor-pointer"
          src={Src}
          alt={Citation?.refFileType}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handleClick(Citation);
          }}
        />
      </figure>

      <div className="px-2 py-1 text-wrap rounded-md flex-1 min-h-16 border border-debatePalette-buttonBorder">
        <span
          className="line-clamp-1 text-debatePalette-title font-bold hover:underline cursor-pointer"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handleClick(Citation);
          }}
        >
          {Citation?.citationTitle || title}
        </span>
        <span className="line-clamp-2">{Citation?.note}</span>
      </div>
      {Actions &&
        Actions?.map((act) => (
          <ActionButton
            key={act.title}
            SVG={act.SVG}
            title={act.title}
            istooltip={false}
            isText={false}
            isDisable={act.isDisable}
            onClick={() =>
              act?.handleClick({
                ...Citation,
                title: Citation?.citationTitle || title,
              })
            }
          />
        ))}
      {menuChildren}
    </div>
  );
};

export default LibraryCard;
